<template>
  <div class="TableField">
    <span v-html="value" />
  </div>
</template>

<script>
export default {
  name: 'TableField',
  computed: {
    value() {
      return this.data[this.header.id];
    },
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
    header: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss">
.TableField {
  font-size: rem(13);
  color: $blue-600;
  height: rem(50);
  display: flex;
  padding-left: rem(10);
  align-items: center;
}
</style>
